import {AxiosResponse} from "axios";
import * as React from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Dialog, {DialogProps} from "@material-ui/core/Dialog";

import {withApi, ApiContextProps} from "hcla-web-frontend-primitives/app/components/primitives/Context/ApiContext";
//@ts-ignore
import CircularIndeterminate from 'hcla-web-frontend-primitives/app/components/primitives/Progress/CircularIndeterminate';
//@ts-ignore
import CancelButton from "hcla-web-frontend-primitives/app/components/primitives/Buttons/CancelButton";

import HCLTreeMxGraphVertexPickerView from "../../SingleHCLModelView/SingleTreeView/MxGraphViews/HCLTreeMxGraphVertexPickerView";
import {HCLTreeMxGraphViewJSON} from "../../SingleHCLModelView/SingleTreeView/MxGraphViews/HCLTreeMxGraphView";
import NodeLabelChip, {NodeLabelChipProps} from "../NodeLabel/NodeLabelChip";

export interface BasicEventChipProps extends NodeLabelChipProps, ApiContextProps {
  dialogProps?: DialogProps;
}

interface State {
  portalOpen: boolean;
  treeData: HCLTreeMxGraphViewJSON;
  treeLoading: boolean;
}

export default class BasicEventChip extends React.Component<BasicEventChipProps, State> {

  constructor(props: BasicEventChipProps) {
    super(props);
    this.state = {
      portalOpen: false,
      treeData: null,
      treeLoading: true,
    };
  }

  private handleClose = (e: React.SyntheticEvent<{}, Event>) => {
    this.setState({ portalOpen: false });
  };

  private handleOpen = (e: React.SyntheticEvent<{}, Event>) => {
    const { map, name, apiManager } = this.props;
    try {
      const { tree_id } = map[name];
      this.setState({ portalOpen: true }, () => {
        apiManager.getTreeWithMetaData(tree_id, (response: AxiosResponse) => {
          this.setState({ treeData: response.data, treeLoading: false});
        });
      });
    } catch (e) {
      return;
    }
  };

  render() {
    const { portalOpen, treeData, treeLoading } = this.state;
    const { dialogProps, ...others } = this.props;
    return (
      <React.Fragment>
        {/*
        // @ts-ignore */}
        <NodeLabelChip {...others} onClick={this.handleOpen} />
        <Dialog
          {...dialogProps}
          open={portalOpen}
          fullWidth
          maxWidth={false}
          onClose={this.handleClose}
          PaperProps={{ style: { height: '100vh', overflow: 'auto' } }}
          disablePortal
        >
          {
            Boolean(treeData) && (
              <DialogTitle>
                <Typography variant="h5" color="textPrimary">{treeData.title}</Typography>
                <Typography variant="subtitle1" color="textSecondary">{treeData.description}</Typography>
              </DialogTitle>
            )}
          <DialogContent>
            {treeLoading && <CircularIndeterminate size={80} color="secondary" />}
            {Boolean(treeData) && <HCLTreeMxGraphVertexPickerView data={treeData} basePath="/model" />}
          </DialogContent>
          <DialogActions>
            <CancelButton
              variant="outlined"
              onClick={this.handleClose}
              size="large"
            >
              Close
            </CancelButton>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
